<template>
  <div>
    <loader :loading="loading"/>
    <b-alert v-if="!loadingAlert && userObjective !== null" variant="danger"
             :show="!userObjective || !userObjective.valid">
      <div class="alert-body">
        <feather-icon icon="InfoIcon" class="mr-50"/>
        Vos objectifs doivent être enregistrés et validés avant de commencer l'auto-évaluation.
      </div>
    </b-alert>


    <div v-if="userObjective && userObjective.valid">
      <div class="d-flex justify-content-end breadcrumb-wrapper pr-1">
        <b-breadcrumb :items="breadcrumbs"/>
      </div>
      <b-progress v-if="isProgress" :value="progress" max="100" animated striped variant="primary" class="mt-3"/>

      <form-wizard ref="evaluation" :start-index="activeTabIndex" color="#7367F0" :title="null" :subtitle="null"
                   :next-button-text=nextButtonText finish-button-text="Enregistrer" back-button-text="Précédent"
                   class="mb-3" @on-complete="handleFinish" @on-change="handleStepChange">

        <tab-content v-for="(componentSection, idx) in componentSections" :key="idx"
                     :title="componentSection.section.title" tag="form"
                     :before-change="() => validationForm(idx, componentSection.section.position)">

          <validation-observer :ref="'componentSection' + idx" tag="form">

            <evaluation-content :refName="`evaluationContent_${idx}`" :userEvaluation="userEvaluation"
                                :componentSection="componentSection" :initForm="initForm" :findResponse="findResponse"
                                :sumFields="sumFields" :isHierarchyModifying="isHierarchyModifying" :userData="userData"
                                :processValueList="processValueList" :fieldValues="fieldValues"
                                :isChange.sync="currentIndex"
                                :position="idx"
                                :config="intervalDays"
                                :fieldErrors="fieldErrors"
                                :evaluationStartDate="evaluationStartDate"
                                @update-next-button="updateNextButtonText"

            />
          </validation-observer>
        </tab-content>
      </form-wizard>

<!--      @auto-save-evaluation="handleAutoSaveEvaluation"
-->


    </div>

    <b-modal id="modal-sm" v-model="isModalActive" modal-class="modal-primary" ok-only ok-title="Envoyer" centered
             size="sm" :title="modalTitle" @hide="onModalClosed" @ok="handleConfirmEvaluation">
      <b-form-group>
        <b-form-radio-group v-model="isValid" :options="options" class="demo-inline-spacing" name="radio-inline"/>
      </b-form-group>
    </b-modal>

  </div>
</template>
<script>
import {BAlert, BBreadcrumb, BProgress} from 'bootstrap-vue';
import {allActiveSections} from '@/services/SectionService';
import {getUserObjectivesByYears} from '@/services/UserObjectiveService';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import {allSectionComponentModelSectionsByPosition} from '@/services/ComponentModelSectionService';
import {getSommeContentById} from '@/services/SommeContentService';
import EvaluationContent from './EvaluationContent.vue';
import Loader from '@/layouts/components/Loader.vue';
import {FormWizard, TabContent} from 'vue-form-wizard';
import {ValidationObserver} from 'vee-validate'
import {
  getIdUserEvaluations,
  getUserEvaluationsByYears,
  saveAutoEvaluation,
  saveEvaluation,
  updateUserEvaluations
} from '@/services/UserEvaluationService';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {getJsonFromStorage} from "@/util/storageUtils";
import {getIdUsers} from "@/services/UserService";
import {getSetting} from "@/services/SettingService";
import moment from "moment/moment";
import {French} from "flatpickr/dist/l10n/fr";
import {getConfigs} from "@/services/EvaluationIntervalConfigsService";


export default {
  components: {
    Loader,
    BAlert,
    BProgress,
    FormWizard,
    TabContent,
    // BBreadcrumb,
    EvaluationContent,
    ValidationObserver,
    // BFormCheckbox,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      isProgress:false,
      update: false,
      loading: false,
      sections: [],
      userData: null,
      userEvaluation: {
        reponses: [],
        evaluationSignature: [{
          reponses: [],
        }]
      },
      userObjective: null,
      loadingAlert: true,
      loadingAlerts: true,
      isValid: false,
      progress: 0,
      activeTabIndex: 0,
      componentSections: [],
      sumFields: [],
      fieldValues: {},
      index: 0,  // Valeur initiale de `index`
      tabIndex: 1,
      // comment: null,
      isEvaluationValidated: false,
      currentIndex: 0,
      isModalActive: false,
      modalTitle: 'Validation',
      currentYear: null,
      isRejectedByN2: false,
      nextButtonText: "Suivant",
      currentSectionPosition: 0,
      intervalDays: 0,
      evaluationStartDate:null,
      sumOrderCounter: 0,
      fieldErrors: {},
      isLeaving: false,
      isSaving: false,
      isSavingSomething: false,
    };
  },
  watch: {
    '$route.name': {
      immediate: true, // Exécute aussi au montage du composant
      handler() {
        this.fetchUserEvaluationData(); // Fonction pour recharger les données
      }
    }
  },
  computed: {
    breadcrumbs() {

      const crumb = this.$route.meta?.breadcrumb?.find(b => b.key === 'evaluation.person');
      // const crumb = this.$route.meta?.breadcrumb ?? []

      const crumbs = crumb ? [crumb] : [];
      const user = this.userEvaluation?.users

      return crumbs.map(b => {
        if (b.key === 'evaluation.person') {
          return {
            ...b,
            text: user
                ? `Personne évaluée : ${user.fullName}`
                : 'Personne évaluée',
          }
        }
        return b
      })
    },



    French() {
      return French
    },

    options() {
      return [
        {text: 'Envoyer au Manager N+2 pour approbation', value: false, disabled: false},
        {text: "Valider l'évaluation", value: true, disabled: this.isRejectedByN2},
      ];
    }

  },
  methods: {

    canAccessEvaluationPage() {
      const userData = this.getStoredUserData();
      if (!this.userEvaluation) return false;
      if (!userData) return false;
      const isOwner = this.userData.id === this.userEvaluation.users?.id;
      const isManager = this.isHierarchyModifying();

      return isOwner || isManager ;
    },


    checkAndRedirectIfInReadOnlyPeriod() {

      if ( !this.userEvaluation?.dateEvaluationPrevu) {
        return false;
      }

      const datePlan = moment(this.userEvaluation.dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);
      if (!datePlan.isValid()) return false;

      const datePlanSubstract = this.getEvaluationDateWithHourSubstracted(this.userEvaluation.dateEvaluationPrevu);



      const isCurrentDateBetween =  moment().isBetween(datePlanSubstract, datePlan);

      const isCurrentDateAfter =  moment().isAfter(datePlan)

      if (isCurrentDateBetween) {

        this.$swal({
          title: 'Alerte!',
          text: "L'évaluation et l'auto évaluation sont en lecture seule pendant cette période !",
          icon: 'info',
          customClass: {confirmButton: 'btn btn-primary'},
          buttonsStyling: false,
        });

        this.$router.push({
          name: 'evaluation_prints',
          params: { id: this.userEvaluation.idPublic }
        });
        return true;
      }
     const userData= this.getStoredUserData();
      const isOwner = userData?.id === this.userEvaluation?.users?.id


      if ((isOwner || this.userEvaluation?.status === "APPROVED"|| this.userEvaluation?.status === "VALIDATED_BY_COLLABORATOR")
          && isCurrentDateAfter) {

        this.$swal({
          title: 'Alerte!',
          text: "L'auto-évaluation ne peut plus être modifiée",
          icon: 'info',
          customClass: {confirmButton: 'btn btn-primary'},
          buttonsStyling: false,
        });

        this.$router.push({
          name: 'evaluation_prints',
          params: { id: this.userEvaluation.idPublic }
        });
        return true;
      }

      return false;
    },

    async updateNextButtonText(nextPosition) {
      const nextIdx = this.componentSections.findIndex(
          s => s.section.position === nextPosition
      );

      const nextSection = this.componentSections[nextIdx + 1];
      const nextTitle = nextSection && nextSection.section.visibilityButton === true
          ? nextSection.section.title
          : null;

      this.nextButtonText = nextTitle || "Suivant";
    },

    async handleAutoSaveEvaluation() {


      if (this.isLeaving || this.isSaving) {
        return false;
      }

      this.isSaving = true;
        try {

          const userConnected = this.getStoredUserData();
          const isManager = this.isHierarchyModifying();
          const {status, dateEvaluationPrevu, idPublic, autoEvaluation, evaluation} = this.userEvaluation;

          if (!autoEvaluation && !isManager) {
            this.userEvaluation = await saveAutoEvaluation(this.userEvaluation);

            return true;
          }

          if (!evaluation && isManager) {
            this.userEvaluation = await saveEvaluation(this.userEvaluation, userConnected.id);

            return true;
          }

          if (["SELF_EVALUATION", "EVALUATION", "TERMINATED", "INPROGRESS"].includes(status)) {

            this.userEvaluation = await updateUserEvaluations(
                idPublic,
                userConnected.id,
                false,
                this.userEvaluation
            );

            return true;
          }

          if (status === "MEETING" && dateEvaluationPrevu) {

            const datePlan = moment(dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);
            const datePlanSubstract = this.getEvaluationDateWithHourSubstracted(dateEvaluationPrevu);

            const isCurrentBeforeDatePlanSubstract = moment().isBefore(datePlanSubstract);
            const isCurrentAfterDatePlan = moment().isAfter(datePlan);
            // || (isCurrentAfterDatePlan && isManager)
            if (isCurrentBeforeDatePlanSubstract) {

              this.userEvaluation = await updateUserEvaluations(
                  idPublic,
                  userConnected.id,
                  false,
                  this.userEvaluation
              );
              return true;
            }

          }


          // if (["VALIDATED_BY_HIERARCHY", "TRANSMIT_HIERARCHY_2", "REJECTED"].includes(status) && isManager || (status === "MEETING" && dateEvaluationPrevu)) {
          if (["VALIDATED_BY_HIERARCHY", "TRANSMIT_HIERARCHY_2", "REJECTED"].includes(status) && isManager || (status === "MEETING" && dateEvaluationPrevu)) {

            // Avec date prévue : vérifier si on est après la date
            const datePlan = moment(dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);
            const isCurrentAfterDatePlan = moment().isAfter(datePlan);


            // if (!isCurrentAfterDatePlan) {
            if (isCurrentAfterDatePlan && isManager) {

              // Avant la date : modification direct
              this.userEvaluation = await updateUserEvaluations(
                  idPublic,
                  userConnected.id,
                  false,
                  this.userEvaluation
              );
              this.progress = 100;
            }
            return true;
          }
          // this.loading = false;

        } catch (error) {

          // this.loading = false;
          if (error.response?.data) {
            const data = error.response.data;

            if (Array.isArray(data.errors) && data.errors.length > 0 &&
                !error.response.data?.errors[0]?.fieldId) {
              this.fieldErrors = {};
              error.response.data.errors.forEach(err => {
                const message = err.message + " " + err.invalidChar + " à la position " + err.position + ".";
                this.$set(this.fieldErrors, err.fieldId, message);
              });
            }
          }
          this.isSaving = false;
          return false;
          // }
        } finally {
          this.isSaving = false;

        }
    },


    onModalClosed(event) {
      if (event.trigger === 'headerclose') {

        this.loading = false; // Désactive l'état de chargement
        this.progress = 0;
      }
    },


    formEvaluation(data) {


      this.$router.push({name: 'evaluation_prints', params: {id: data.idPublic}});

    },


    handleConfirmEvaluation() {
      this.confirmEvalueEvaluation(false);
    },

    async confirmEvalueEvaluation(value) {
      this.progress = 30;
      if (!this.loading) {

        if (value) {
          this.userEvaluation.validHierachy = true;
        } else {
          this.userEvaluation.validHierachy = this.isValid;
        }
        this.progress = 60;

        try {
          this.loading=true;

          const userConnected = this.getStoredUserData();
          this.progress = 80;

          this.userEvaluation = await updateUserEvaluations(
              this.userEvaluation.idPublic,
              userConnected.id,
              true,
              this.userEvaluation
          );
          this.progress = 100;

          if (value) {
            this.$swal({
              title: 'Évaluation validée',
              icon: 'success',
              text: 'Évaluation validée avec succès.',
              timer: 3000,
              showConfirmButton: true,
              confirmButtonText: 'OK',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.formEvaluation(this.userEvaluation);
              }

              if (result.dismiss === 'timer') {
                this.formEvaluation(this.userEvaluation);
              }
            });

          } else {
            this.showToast(
                "Évaluation validée avec succès.",
                "success",
                'EditIcon'
            );
            this.formEvaluation(this.userEvaluation);
          }
          this.loading = false;

        } catch (e) {
          console.error(e);
          this.showToast(
              "Erreur dans la validation de l'évaluation.",
              "danger",
              'EditIcon'
          );
          this.fieldErrors = {};

          e.response.data.errors.forEach(err => {
            const message = err.message + " " + err.invalidChar + " à la position " + err.position + ".";
            this.$set(this.fieldErrors, err.fieldId, message);
          });
        }
      }
    },



    validationForm(index, positionSection) {
      this.tabIndex = index;
      this.currentIndex = positionSection



      return new Promise((resolve, reject) => {
        if (this.isLeaving) {
          resolve(true);
          return;
        }
        if (index === 0) {
          resolve(true);
          return;
        }
        const observer = this.$refs['componentSection' + index];
        if (observer) {
          observer[0].validate().then(async success => {
            if (success) {

              if(this.componentSections.length !== this.currentIndex) {
                const saved = await this.handleAutoSaveEvaluation();

                if (!saved) {
                  reject();
                }
              }

              resolve(true);

            } else {
              reject();
            }
          }).catch(err => {
            console.error("Erreur de validation :", err);
            reject();
          });
        } else {
          console.error("Erreur de validation :reject");

          reject();
        }
      });
    },


    updateValidationOptions() {
      this.isRejectedByN2 = this.userEvaluation?.status === 'REJECTED';
    },


    async handleFinish() {

      this.isSavingSomething = true;

      this.isProgress= true;
      this.progress = 0;
      if (this.isLeaving || this.isSaving) {
        return false;
      }

      this.isSaving = true;

        try {

          let userConnected = this.getStoredUserData();
          const isManager = this.isHierarchyModifying();
          const {status, dateEvaluationPrevu, idPublic, autoEvaluation, evaluation} = this.userEvaluation;


          if (!autoEvaluation && !isManager) {
            this.progress = 40;
            this.userEvaluation = await saveAutoEvaluation(this.userEvaluation);
            this.userEvaluation.status = "SELF_EVALUATION";
            this.showToast("Auto-évaluation enregistrée avec succès.", "success", 'EditIcon');
            this.formEvaluation(this.userEvaluation);
            this.progress = 100;
            return;
          }

          if (!evaluation && isManager) {
            this.progress = 40;
            this.userEvaluation = await saveEvaluation(this.userEvaluation, userConnected.id);
            this.userEvaluation.status = "EVALUATION";
            this.showToast("Évaluation enregistrée avec succès.", "success", 'EditIcon');
            this.formEvaluation(this.userEvaluation);
            this.progress = 100;
            return;
          }

          if (["APPROVED", "VALIDATED_BY_COLLABORATOR"].includes(status)) {
            const message = isManager
                ? "L'évaluation ne peut plus être modifiée !"
                : "L'auto-évaluation ne peut plus être modifiée !";

            this.progress = 100;
            this.loading = false;

            this.formEvaluation(this.userEvaluation);

            this.$swal({
              title: 'Alerte!',
              text: message,
              icon: 'info',
              customClass: {confirmButton: 'btn btn-primary'},
              buttonsStyling: false,
            });
            return;
          }

          if (["SELF_EVALUATION", "EVALUATION", "TERMINATED", "INPROGRESS"].includes(status)) {
            this.progress = 40;
            this.loading = true;

            if (autoEvaluation === true && !isManager) {
              this.userEvaluation.autoEvaluationFin = true;
            }

            this.userEvaluation = await updateUserEvaluations(
                idPublic,
                userConnected.id,
                true,
                this.userEvaluation
            );

            const message = isManager
                ? "Évaluation modifiée avec succès."
                : "Auto-évaluation modifiée avec succès.";

            this.showToast(message, "success", 'EditIcon');
            this.progress = 80;

            this.formEvaluation(this.userEvaluation);
            this.progress = 100;
            return;
          }


          if (status === "MEETING" && dateEvaluationPrevu) {
            this.progress = 40;
            this.loading = true;

            const datePlan = moment(dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);
            const datePlanSubstract = this.getEvaluationDateWithHourSubstracted(dateEvaluationPrevu);

            const isCurrentBeforeDatePlanSubstract = moment().isBefore(datePlanSubstract);
            const isCurrentDateBetween = moment().isBetween(datePlanSubstract, datePlan);
            const isCurrentAfterDatePlan = moment().isAfter(datePlan);

            if (isCurrentBeforeDatePlanSubstract) {
              if (autoEvaluation === true && !isManager) {
                this.userEvaluation.autoEvaluationFin = true;
              }
              this.userEvaluation = await updateUserEvaluations(
                  idPublic,
                  userConnected.id,
                  true,
                  this.userEvaluation
              );

              const message = isManager
                  ? "Évaluation modifiée avec succès."
                  : "Auto-évaluation modifiée avec succès.";

              this.showToast(message, "success", 'EditIcon');
              this.progress = 80;

              this.formEvaluation(this.userEvaluation);
              this.progress = 100;
              return;
            }

            if (isCurrentDateBetween) {
              const message = isManager
                  ? "L'évaluation est en lecture seule pendant cette période."
                  : "L'auto-évaluation est en lecture seule pendant cette période.";

              this.progress = 100;
              this.loading = false;

              this.formEvaluation(this.userEvaluation);

              this.$swal({
                title: 'Alerte!',
                text: message,
                icon: 'info',
                customClass: {confirmButton: 'btn btn-primary'},
                buttonsStyling: false,
              });

              return;
            }
            // Après datePrevue
            if (isCurrentAfterDatePlan) {
              // Collaborateur : blocage définitif
              if (!isManager) {

                this.progress = 100;
                this.loading = false;

                this.formEvaluation(this.userEvaluation);

                this.$swal({
                  title: 'Alerte!',
                  text: "Vous ne pouvez plus modifier l'auto-évaluation !",
                  icon: 'warning',
                  customClass: {confirmButton: 'btn btn-primary'},
                  buttonsStyling: false,
                });

                return;
              }

            }
          }


          if (["VALIDATED_BY_HIERARCHY", "TRANSMIT_HIERARCHY_2", "REJECTED"].includes(status) || (status === "MEETING" && dateEvaluationPrevu)) {
            if (!isManager) {
              this.progress = 100;
              this.loading = false;

              this.$swal({
                title: 'Alerte!',
                text: "Vous ne pouvez plus modifier l'auto-évaluation !",
                icon: 'warning',
                customClass: {confirmButton: 'btn btn-primary'},
                buttonsStyling: false,
              });

              this.formEvaluation(this.userEvaluation);

            } else {
              const datePlan = moment(dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);
              const isCurrentAfterDatePlan = moment().isAfter(datePlan);
              this.progress = 10;

              if (isCurrentAfterDatePlan) {

                if (userConnected.usersHierarchique[0]) {
                  this.progress = 20;

                  this.isModalActive = true;

                } else {

                  this.progress = 20;

                  await this.confirmEvalueEvaluation(true);


                }

                if (["REJECTED", "MEETING", "TRANSMIT_HIERARCHY_2"].includes(status)) {
                  this.updateValidationOptions();
                }

                this.progress = 100;

              } else {
                this.loading = true;

                // Avant la date : modification directe
                this.userEvaluation = await updateUserEvaluations(
                    idPublic,
                    userConnected.id,
                    true,
                    this.userEvaluation
                );

                this.showToast("Évaluation modifiée avec succès.", "success", 'EditIcon');
                this.progress = 100;
                this.formEvaluation(this.userEvaluation);
              }
            }
          }

          this.loading = false;

        } catch (error) {
          if (error.response?.data) {
            const data = error.response.data;

            if (Array.isArray(data.errors) && data.errors.length > 0 &&
                !error.response.data?.errors[0]?.fieldId) {
              this.fieldErrors = {};
              error.response.data.errors.forEach(err => {
                const message = err.message + " " + err.invalidChar + " à la position " + err.position + ".";
                this.$set(this.fieldErrors, err.fieldId, message);
              });
            }
          }

          console.error("Erreur lors de l'enregistrement:", error);
          this.showToast("Une erreur s'est produite lors de l'enregistrement.", "danger", "ErrorIcon");
          this.progress = 0;
          this.isSaving = false;
          this.isSavingSomething = false;
        }finally {
          this.isSaving = false;
          this.isSavingSomething = false;

        }

    },




    handleStepChange(prevIndex, nextIndex) {

      if (nextIndex < prevIndex) {

        const nextIdx = this.componentSections.findIndex(
            s => s.section.position === nextIndex + 1
        );

        const nextSection = this.componentSections[nextIdx + 1];


        const nextTitle = nextSection && nextSection.section.visibilityButton === true
            ? nextSection.section.title
            : null;
        this.nextButtonText = nextTitle || "Suivant";

        if (!this.isLeaving) {

          this.handleAutoSaveEvaluation()
        }

      }

      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });

    },

    getStoredUserData() {
      const storedUserData = getJsonFromStorage('userData');
      return storedUserData ? storedUserData : null;
    },

    isHierarchyModifying() {

      const userData = this.getStoredUserData();
      return userData && userData?.id === this.userEvaluation.users?.usersHierarchique[0]?.id

    },



    async fetchUserEvaluationData() {

      const userEvaluationId = this.$route.query.id
      const userId = this.$route.query.userId
      const year = this.$route.query.year

      const settingResponse = await getSetting();

      if (year) {
        this.currentYear = year;
        if (settingResponse ) {
          this.evaluationStartDate = settingResponse.evaluationStartDate;
        }
      } else {
        if (settingResponse && settingResponse.yearEvaluation) {
          this.currentYear = settingResponse?.yearEvaluation?.year;

        }else{
          this.$swal({
            title: 'Alerte!',
            text: "L’année de l’évaluation n’est pas configurée.",
            icon: 'info',
            customClass: {confirmButton: 'btn btn-primary'},
            buttonsStyling: false,
          });
          await this.$router.push({
            name: 'profile'});
          return;
        }
      }

      if (!userEvaluationId && !userId) {
        this.userData = this.getStoredUserData();

        if (this.userData) {
          try {
            const evaluationResponse = await getUserEvaluationsByYears(this.userData.id, this.userData.id, this.currentYear);
            if (evaluationResponse) {
              this.userEvaluation = evaluationResponse;
            } else {
              this.userEvaluation.users = this.userData;
            }
          } catch (error) {
            console.error('Erreur lors de la récupération des objectifs utilisateur par année :', error);
          }
        }
      }

      else if (userEvaluationId) {
        this.userData = this.getStoredUserData();
        try {
          const evalResponse = await getIdUserEvaluations(userEvaluationId,this.userData.id);

          if (evalResponse) {
            this.userEvaluation = evalResponse;
            this.userData = evalResponse.users;
          }
        } catch (error) {
          console.error("Erreur de récupération des données d'évaluation utilisateur :", error);
        }
      }

      else if (userId) {
        try {
          const userResponse = await getIdUsers(userId);
          const userDataConnected = this.getStoredUserData();

          if (userResponse) {
            const userEvalResponse = await getUserEvaluationsByYears(userResponse.id,userDataConnected.id, this.currentYear);
            if (userEvalResponse) {
              this.userEvaluation = userEvalResponse;
            } else {
              this.userEvaluation.users = userResponse;
              this.userData = userResponse;
            }
          }
        } catch (error) {
          console.error("Erreur lors du chargement de l'utilisateur :", error);
        }
      }


      if(this.userEvaluation?.idPublic) {
        this.currentYear = this.userEvaluation?.years;
      }


      if (!this.canAccessEvaluationPage) {
        if (this.$route.name !== 'profile') {
          await this.$router.replace({ name: 'profile' });
        }
        return;
      }


      const redirected = this.checkAndRedirectIfInReadOnlyPeriod();
      if (redirected) {
        return;
      }

      if (
          !Array.isArray(this.userEvaluation.evaluationSignature) ||
          this.userEvaluation.evaluationSignature.length === 0
      ) {
        this.userEvaluation.evaluationSignature = [
          { users: this.getStoredUserData(), reponses: [] },
        ];
      } else {
        this.userEvaluation.evaluationSignature[0] = {
          ...this.userEvaluation.evaluationSignature[0],
          users: this.getStoredUserData(),
          reponses: this.userEvaluation.evaluationSignature[0].reponses || [],
        };
      }

      await this.fetchSections();

      if (this.isHierarchyModifying()) {
        await this.getConfigByUser();
      }

    },

    async getConfigByUser() {
      const userConnected = this.getStoredUserData();

      const reponse = await getConfigs(userConnected.id);
      this.intervalDays = reponse.intervalDays;
    },

    async fetchSommeContentById(id) {
      return await getSommeContentById(id);

    },

    async fetchSections() {
      try {
        this.loading = true
        const filteredSections = await allActiveSections();

        this.sections = (this.isHierarchyModifying()
                ? filteredSections.filter(section => section.categories.includes("Supérieur hiérarchique"))
                : filteredSections.filter(section => section.categories.includes("Personne évaluée"))
        ).filter(section => {
          // Si dateEvaluationPrevu n'existe pas, on garde toutes les sections


          // if (this.userEvaluation?.proposeDate===2) return false;

          if (!this.userEvaluation?.dateEvaluationPrevu) return true;
          const now = moment();

          const datePrevue = moment(this.userEvaluation.dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);

          const visibilityHours = section.visibilityTime || 0;

          if (!visibilityHours) return true;

          const hideFrom = datePrevue.clone().subtract(visibilityHours, "hours");

          return now < hideFrom;
        });

        this.componentSections = await Promise.all(
            this.sections.map(async section => {
              try {


                const content = (await allSectionComponentModelSectionsByPosition(section.position)) || [];

                await this.updateObjective();

                for (const cont of content) {
                  if (cont.objectif && this.userObjective?.objectifs) {
                    section.coef = this.userObjective.note;
                    const objectives = this.userObjective.objectifs.sort((a, b) => a.idObjective - b.idObjective);


                    cont.componentModels = objectives.map(objective => ({
                      titre: objective.objectif,
                      indicateur : objective.description,
                      objective: true,
                      idPublic: objective.id,
                      note: objective.note,
                    }));
                  }

                  if (cont.contentSections && cont.componentModels) {
                    if (cont.componentModels.length > 0) {
                      for (const componentModel of cont.componentModels) {
                        for (const contentSection of cont.contentSections) {

                          const matchingSignature = this.userEvaluation?.evaluationSignature?.find(
                              signature => signature?.hierarchyN === 1
                          );

                          const responsesList = this.isHierarchyModifying()
                              ? matchingSignature?.reponses || []
                              : this.userEvaluation?.reponses;


                          if (Array.isArray(responsesList)) {
                            // const exists = responsesList.some(
                            //     response =>
                            //         (response.componentModel?.idPublic === componentModel.idPublic &&
                            //             response.contentSection?.idPublic === contentSection.idPublic) ||
                            //         (response.objective?.id === componentModel.idPublic &&
                            //             response.contentSection?.idPublic === contentSection.idPublic)
                            // );
                             const existing = this.findResponse(componentModel, contentSection, section.position);
                            if (!existing) {

                              if (contentSection.response) {
                                // Ajout d'une nouvelle réponse
                                const newResponse = componentModel.objective
                                    ? {
                                      idPublic: null,
                                      objective: {id: componentModel.idPublic},
                                      contentSection: {idPublic: contentSection.idPublic,section: {idPublic: section.idPublic,position: section.position}},
                                    }
                                    : {
                                      idPublic: null,
                                      componentModel: {idPublic: componentModel.idPublic},
                                      contentSection: {idPublic: contentSection.idPublic,section: {idPublic: section.idPublic,position: section.position}},
                                    };

                                responsesList.push(newResponse);
                              }

                            } else {
                              // Réponse déjà existante → initialisation du formulaire

                              const value = this.getComponentModel(
                                  componentModel,
                                  contentSection,
                                  section.position
                              );
                              await this.initForm(value, componentModel, contentSection, section.position, true);

                            }
                          }

                          if (contentSection.somme) {
                            const uniqueKey = componentModel.somme
                                ? `${contentSection.idPublic}_${componentModel.idPublic}`
                                : contentSection.idPublic;
                            this.sumOrderCounter += 1;
                            if (!this.sumFields[uniqueKey]) {
                              this.sumFields[uniqueKey] = {
                                section,
                                modal: contentSection,
                                ...(componentModel.somme ? {table: componentModel} : {}),
                                order: this.sumOrderCounter,
                              };
                            }
                            const sommeContentSource = componentModel.somme ? componentModel : contentSection;


                            if (sommeContentSource.sommeContent) {

                              try {
                                sommeContentSource.sommeContent = await this.fetchSommeContentById(
                                    sommeContentSource.sommeContent.idPublic
                                );


                                sommeContentSource.sommeContent.componentModel = sommeContentSource.sommeContent.componentModel || [];

                                if (
                                    sommeContentSource === contentSection &&
                                    contentSection.objectif &&
                                    this.userObjective?.objectifs
                                ) {
                                  this.userObjective.objectifs.forEach(objective => {
                                    sommeContentSource.sommeContent.componentModel.push({
                                      titre: objective.objectif,
                                      objective: true,
                                      idPublic: objective.id,
                                      note: objective.note,
                                    });
                                  });

                                }

                                if (componentModel.somme) {

                                  componentModel.sectionIdPublic = sommeContentSource.sommeContent.contentSection.section.idPublic;

                                  this.sumFields[uniqueKey][
                                      sommeContentSource === contentSection ? "modal" : "table"
                                      ] = sommeContentSource;

                                } else {


                                  this.sumFields[contentSection.idPublic].modal = sommeContentSource;

                                }

                                await this.initForm(0, componentModel, contentSection, section.position, false);
                              } catch (error) {
                                console.error("Erreur lors de la récupération des données :", error);
                              }
                            }
                          }
                        }
                      }
                    } else {
                      for (const contentSection of cont.contentSections) {

                        const matchingSignature = this.userEvaluation?.evaluationSignature?.find(
                            signature => signature?.hierarchyN === 1
                        );

                        const responsesList = this.isHierarchyModifying()
                            ? matchingSignature?.reponses || []
                            : this.userEvaluation?.reponses;

                        if (Array.isArray(responsesList)) {

                          const existing = this.findResponse(null, contentSection, section.position);

                          if (!existing) {
                            // Ajout d'une nouvelle réponse

                            if (contentSection.response) {
                              const newResponse = {
                                idPublic: null,
                                contentSection: {idPublic: contentSection.idPublic,section: {idPublic: section.idPublic,position: section.position}},
                              };

                              responsesList.push(newResponse);
                            } else {

                              const dateValue = this.userEvaluation.status === 'MEETING' ? this.userEvaluation.dateEvaluationPrevu : this.userEvaluation.dateEvaluationPropose;
                              let value
                              if (dateValue) {
                                const m = moment(dateValue, "DD-MM-YYYY HH:mm");

                                if (m.isValid()) {
                                  value = m.toDate();

                                }
                              } else {
                                value = null
                              }

                              await this.initForm(value, null, contentSection, section.position, true);

                            }
                          } else {

                            const value = this.getComponentModel(
                                null,
                                contentSection,
                                section.position
                            );
                            await this.initForm(value, null, contentSection, section.position, true);
                          }
                        }

                        // Gestion des champs somme
                        if (contentSection.somme) {
                          const uniqueKey = contentSection.idPublic;

                          if (!this.sumFields[uniqueKey]) {
                            this.sumFields[uniqueKey] = {
                              section,
                              modal: contentSection,
                            };
                          }
                          const sommeContentSource = contentSection;


                          if (sommeContentSource.sommeContent) {

                            try {
                              sommeContentSource.sommeContent = await this.fetchSommeContentById(
                                  sommeContentSource.sommeContent.idPublic
                              );


                              sommeContentSource.sommeContent.componentModel = sommeContentSource.sommeContent.componentModel || [];

                              if (
                                  sommeContentSource === contentSection &&
                                  contentSection.objectif &&
                                  this.userObjective?.objectifs
                              ) {
                                this.userObjective.objectifs.forEach(objective => {
                                  sommeContentSource.sommeContent.componentModel.push({
                                    titre: objective.objectif,
                                    objective: true,
                                    idPublic: objective.id,
                                    note: objective.note,
                                  });
                                });
                              }


                              this.sumFields[contentSection.idPublic].modal = sommeContentSource;

                              await this.initForm(0, null, contentSection, section.position, false);
                            } catch (error) {
                              console.error("Erreur lors de la récupération des données :", error);
                            }
                          }
                        }
                      }
                    }

                  }
                }

                this.loading = false;
                return {section, content};
              } catch (err) {
                console.error("Erreur dans le traitement de la section :", err);
                this.loading = false;
                return null;
              }
            })
        );
        // Nettoyage : supprime les sections null
        this.componentSections = this.componentSections.filter(Boolean);


        if (this.isHierarchyModifying()) {
          const matchingSignature = this.userEvaluation?.evaluationSignature?.find(
              signature => signature?.hierarchyN === 1
          );
          if (matchingSignature) {
            matchingSignature.reponses =
                this.deduplicateResponses(matchingSignature.reponses);
          }
        } else {
          this.userEvaluation.reponses =
              this.deduplicateResponses(this.userEvaluation.reponses);
        }

        // Gestion des coefficients
        const sectionsAvecCoef = this.componentSections
            .map(item => item?.section)
            .filter(section => section && section.requiredCalcul);

        const sectionAvecCoefFixe = sectionsAvecCoef.find(section => section.coef != null);
        const autresSections = sectionsAvecCoef.filter(section => section !== sectionAvecCoefFixe);

        if (sectionAvecCoefFixe && autresSections.length > 0) {
          const reste = 100 - sectionAvecCoefFixe.coef;
          const repartition = reste / autresSections.length;
          autresSections.forEach(section => {
            section.coef = repartition;
          });
        }

        function getIdPublic(v) {
          if (!v) return null;
          return (typeof v === 'object') ? (v.idPublic ?? v.id ?? null) : v;
        }

        const sectionCoefMap = new Map();
        this.componentSections.forEach(sObj => {
          const sid = getIdPublic(sObj?.section?.idPublic);
          if (sid != null && typeof sObj.section.coef !== 'undefined') {
            sectionCoefMap.set(sid, sObj.section.coef);
          }
        });

        this.componentSections.forEach(sectionObj => {
          sectionObj?.content?.forEach(cont => {
            cont.componentModels?.forEach(componentModel => {
              const targetId = getIdPublic(componentModel.sectionIdPublic);
              if (!targetId) return;

              const coef = sectionCoefMap.get(targetId);
              if (typeof coef !== 'undefined') {
                componentModel.note = coef;


                Object.values(this.sumFields).forEach(field => {
                  const target = field.table || field.modal;
                  if (target?.sommeContent?.componentModel) {
                    target.sommeContent.componentModel.forEach(model => {
                      if (model.idPublic === componentModel.idPublic) {
                        model.note = coef;
                      }
                    });
                  }
                });
              }
            });
          });
        });

      } catch (error) {
        console.error("Erreur lors du chargement des sections :", error);
      }
    },

    async updateObjective() {
      try {
        this.userObjective = await getUserObjectivesByYears(this.userData.id, this.currentYear);

        this.loadingAlerts = false;
      } catch (error) {
      } finally {
        this.loadingAlert = false;
      }
    },

    isStandard(sectionId) {

      if (!sectionId) return false;
      const section = this.sections.find(sec => sec.position === sectionId);
      return section && section.responseChoice === 'Standard';
    },

    async initForm(value, componentsTable, component, sectionID, exists) {

      if (!exists) {

        const totalVal = this.updateResponseValue(value, componentsTable, component, sectionID)

        if (totalVal) {
          Object.keys(totalVal).forEach((key) => {
            const fieldData = totalVal[key];
            const keys = componentsTable
                ? `${fieldData.contentSection.idPublic}_${fieldData.componentModel.idPublic}_${sectionID}`
                : `${fieldData.contentSection.idPublic}_${sectionID}`;
            let values = fieldData?.answerDouble
                ? fieldData.answerDouble
                : fieldData?.answerString  // Si non null, et non vide
                    ? fieldData.answerString
                    : 0;

            this.$set(this.fieldValues, keys, values);
          });
          // if(component.somme){ }
        }


      } else {

        const key = componentsTable
            ? `${component.idPublic}_${componentsTable.idPublic}_${sectionID}`
            : `${component.idPublic}_${sectionID}`;


        this.$set(this.fieldValues, key, value);

      }

    },

    getComponentModel(componentsTable, component, componentsId) {
      const foundResponse = this.findResponse(componentsTable, component, componentsId);
      if (foundResponse) {
        const responseType = component.champsModel.typeReponse;

        switch (responseType) {
          case 'string':
            return foundResponse.answerString || '';
          case 'date':
            return foundResponse.answerDate || null;
          case 'integer':
            return foundResponse.answerInteger || 0;
          case 'double':
            return foundResponse.answerDouble || 0;
          case 'boolean':
            return foundResponse.answerBoolean || false;
          case 'list':
            return foundResponse.answerList || [];
          default:
            return null;
        }
      }
      return null;
    },

    findResponse(componentsTable, component, componentsId) {
      let foundResponse = null;

      const matchingSignature = this.userEvaluation?.evaluationSignature?.find(
          signature => signature?.hierarchyN === 1
      );

      const responsesList = this.isHierarchyModifying()
          ? matchingSignature?.reponses || []
          : this.userEvaluation.reponses;

      foundResponse = responsesList.find((response) => {
        // const hasContentSection = response.contentSection && response.contentSection.idPublic === component.idPublic;

        const hasContentSection =
            response.contentSection &&
            response.contentSection.idPublic === component.idPublic &&
            response.contentSection.section?.position === componentsId;

        if (componentsTable?.idPublic && !this.isStandard(componentsId)) {
          return hasContentSection && (
              (response.componentModel && response.componentModel.idPublic === componentsTable.idPublic) ||
              (response.objective && response.objective.id === componentsTable.idPublic)
          );
        } else {
          return hasContentSection;
        }
      });


      return foundResponse;
    },

    updateResponseValue(value, componentsTable, component, sectionID) {

      if (component.response) {
        const foundResponse = this.findResponse(componentsTable, component, sectionID);

        if (foundResponse) {
          const responseType = component.champsModel.typeReponse;

          if (value !== undefined && value !== null) {

            switch (responseType) {
              case 'string':

                foundResponse.answerString = value.toString();  // S'assure que la valeur est une chaîne
                break;
              case 'date':
                foundResponse.answerDate = new Date(value);     // Convertit en objet Date si nécessaire
                break;
              case 'integer':
                foundResponse.answerInteger = parseInt(value, 10); // Assure que la valeur est un entier
                break;
              case 'double':
                foundResponse.answerDouble = value; // Assure que la valeur est un entier
                break;
              case 'boolean':
                foundResponse.answerBoolean = !!value;          // Convertit en booléen
                break;
              case 'list':
                if (Array.isArray(value)) {
                  foundResponse.answerList = value;             // S'assure que la valeur est une liste
                } else {
                  console.warn("La valeur fournie n'est pas une liste.");
                }
                break;
              default:
                console.warn("Type de réponse inconnu pour ce composant : ", component.titre);
            }


            const matchingSignature = this.userEvaluation?.evaluationSignature?.find(
                signature => signature?.hierarchyN === 1
            );

            const responsesList = this.isHierarchyModifying()
                ? matchingSignature?.reponses || []
                : this.userEvaluation.reponses;


            if (responsesList && Array.isArray(responsesList)) {
              const existingResponseIndex = responsesList?.findIndex(res => {

                const hasContentSection =
                    res.contentSection &&
                    res.contentSection.idPublic === component.idPublic &&
                    res.contentSection.section?.position === sectionID;

                    if (this.isStandard(sectionID)) {
                      return hasContentSection;
                    } else {


                      return hasContentSection && (
                          (res.componentModel && res.componentModel.idPublic === foundResponse.componentModel.idPublic) ||
                          (res.objective && res.objective.id === foundResponse.objective.id)
                      );
                    }
                  }
              );
              if (existingResponseIndex !== -1) {
                responsesList.splice(existingResponseIndex, 1, foundResponse);
              } else {
                const alreadyExists = responsesList.find(res =>
                    res.contentSection?.idPublic === foundResponse.contentSection?.idPublic &&
                    (
                        res.componentModel?.idPublic === foundResponse.componentModel?.idPublic ||
                        res.objective?.id === foundResponse.objective?.id
                    )
                );

                if (!alreadyExists) {
                  responsesList.push(foundResponse);
                }
              }

              // if (existingResponseIndex !== -1) {
              //   responsesList[existingResponseIndex] = foundResponse;
              // } else {
              //   responsesList.push(foundResponse);
              // }
            }
            const cleaned = this.deduplicateResponses(responsesList);

            if (this.isHierarchyModifying()) {
              matchingSignature.reponses = cleaned;
            } else {
              this.userEvaluation.reponses = cleaned;
            }

            return this.calculAutomatique(sectionID);
          } else {
            console.warn("Valeur non valide reçue pour le composant : ", component.titre);
          }
        }

      } else {


        if (!this.userEvaluation.proposeDate || this.userEvaluation.proposeDate < 2) {
          if (value === 0 || value === '' || value === null) {
            // this.userEvaluation.dateEvaluationPropose = null;
          } else {
            if (this.userEvaluation.status === 'MEETING') {
              this.userEvaluation.dateEvaluationPrevu = value;
            } else {
              this.userEvaluation.dateEvaluationPropose = value;
            }
          }
        } else {
          this.showToast("Nombre maximal de propositions atteint", "danger", "BellIcon");

        }

      }

    },

    calculAutomatique(sectionID) {

      if (!this.sumFields) return;
           const sortedEntries = Object.entries(this.sumFields)
          .sort(([, a], [, b]) => (a.order || 0) - (b.order || 0));

      const allResults = {};
      const matchingSignature = this.userEvaluation?.evaluationSignature?.find(
          signature => signature?.hierarchyN === 1
      );

      const responsesLists = this.isHierarchyModifying()
          ? matchingSignature?.reponses || []
          : this.userEvaluation.reponses;
      // sortedSumFields.forEach((sumFieldGroup) => {
      sortedEntries.forEach(([key, sumFieldGroup]) => {
        // const sumFieldGroup = this.sumFields[key];
        const sumFieldGroupsArray = Array.isArray(sumFieldGroup)
            ? sumFieldGroup
            : sumFieldGroup && sumFieldGroup.table
                ? [{modal: sumFieldGroup.modal, table: sumFieldGroup.table, section: sumFieldGroup.section}]
                : [{modal: sumFieldGroup.modal, table: {}, section: sumFieldGroup.section}];


        sumFieldGroupsArray.forEach((sumFiel) => {
          // if (sectionID && sumFiel.section.position === sectionID) {
          // if (!sectionID || sumFiel.section.position === sectionID) {
            let totalPondere = 0;
            let totalCoefs = 0;
            let foundSum = 0;
            const sommeContent = sumFiel.modal?.sommeContent || sumFiel.table?.sommeContent;

            if (sommeContent?.idPublic) {
              if (sumFiel.table && sommeContent.componentModels?.idPublic && sommeContent.componentModels?.idPublic === sumFiel.table.idPublic) {
                responsesLists.forEach((res) => {
                  if (res.contentSection?.idPublic === sommeContent.contentSection.idPublic) {
                    foundSum += res?.answerDouble || 0;
                  }
                });

              } else if (Array.isArray(sommeContent.componentModel)) {

                if (sommeContent.componentModel.length === 0) {

                  responsesLists.forEach((res) => {
                    if (res.contentSection?.idPublic === sommeContent.contentSection.idPublic) {

                      if (sumFiel.modal.champsModel.typeReponse === "string") {

                        foundSum = this.processValueList(sumFiel.modal.valueList, res?.answerDouble || 0)[0];
                      } else {
                        foundSum += res?.answerDouble || 0;
                      }
                    }
                  });
                } else {


                  sommeContent.componentModel.forEach((model) => {
                    responsesLists.forEach((res) => {

                      const modelIdToCompare = res.componentModel?.idPublic || res.objective?.id;


                      if (
                          res.contentSection?.idPublic === sommeContent.contentSection.idPublic &&
                          modelIdToCompare === model.idPublic
                      ) {


                        if (sumFiel.modal.champsModel.typeReponse === "string") {

                          foundSum = this.processValueList(sumFiel.modal.valueList, res?.answerDouble || 0)[0];

                        } else if (typeof res.answerDouble === 'number') {

                          let coef = (model.note || 0) / 100;
                          totalPondere += res.answerDouble * coef;
                          totalCoefs += coef;

                        }


                      }
                    });
                  });

                  if (totalCoefs > 0) {
                    foundSum = totalPondere;
                  }


                }


              }

              let existingResponse;

              foundSum = typeof foundSum === 'number'
                  ? Math.round(foundSum)
                  : foundSum;

              if (sumFiel.table.somme) {

                existingResponse = responsesLists.find(
                    rest => rest.contentSection?.idPublic === sumFiel.modal.idPublic &&
                        rest.componentModel?.idPublic === sumFiel.table?.idPublic
                );


              } else {

                existingResponse = responsesLists.find(
                    rest => rest.contentSection?.idPublic === sumFiel.modal.idPublic ||
                        (rest.contentSection?.idPublic === sumFiel.modal.idPublic &&
                            rest.componentModel?.idPublic === sumFiel.table?.idPublic)
                );

              }
              if (existingResponse) {
                if (
                    (existingResponse.answerDouble !== null &&
                        existingResponse.answerDouble !== undefined &&
                        existingResponse.answerDouble !== 0) &&
                    foundSum === 0
                ) {
                  return;
                }
                 existingResponse[typeof foundSum === 'string' ? 'answerString' : 'answerDouble'] = foundSum;

                allResults[key] = existingResponse;


              }

            }
          // }
        });
      });

      return allResults;
    },

    processValueList(valueList, value) {
      if (!Array.isArray(valueList)) return [];
      const normalizedValue =
          typeof value === 'number' ? Math.round(value) : value;
      return valueList
          .slice() // Créer une copie pour éviter de modifier l'original
          .reverse() // Parcourir en ordre inverse
          .map((item) => {
            if (typeof item !== "string") {
              item = String(item || "");
            }

            const match = item.match(/^(.+?)\[(\d+),(\d+)]$/);
            if (match) {
              const name = match[1];
              const inferieur = parseInt(match[2], 10);
              const superieur = parseInt(match[3], 10);

              // if ((value === 0 && inferieur === 0) || (value >= inferieur && value <= superieur)) {
              //   return name;
              // }
              if (
                  normalizedValue === null ||
                  (normalizedValue >= inferieur &&
                      normalizedValue <= superieur)
              ) {
                return name;
              }
              if (value === null) {
                return name;
              }
              return null;
            }

            return item;
          })
          .filter(Boolean); // Supprimer les valeurs nulles
    },

    showToast(message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon: icon,

          timeout: 8000,
          text: message,
          variant: color,
        },
      });
    },
    deduplicateResponses(list) {
      if (!Array.isArray(list)) return [];
      const map = new Map();
      list.forEach(res => {
        const key = `${res.contentSection?.idPublic}_${
            res.componentModel?.idPublic || res.objective?.id || ''
        }_${res.contentSection?.section?.position || ''}`;

        map.set(key, res);
      });
      return Array.from(map.values());
    },



    getEvaluationDateWithHourSubstracted(date) {
      if (!date) {
        this.showToast('Erreur', 'La date de validation est manquante', 'danger');
        return;
      }
      const currentDate = moment(date, "DD-MM-YYYY HH:mm", true);
      return currentDate.subtract(36, 'hours');
    },
  },
  beforeRouteLeave(to, from, next) {
    this.isLeaving = true;
    next();
  },
};
</script>


<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
